module.exports = __webpack_public_path__ + "img/green.c8dc32fc.svg";